import React, { Component } from 'react'
import { connect } from 'react-redux'
import FileDisplay from 'components/file/file-display'
import Icon from 'components/icon/icon'
import Swipeable from 'react-swipeable'

import { withRouter } from 'react-router'

import {
	deleteFile,
	openModal
} from 'state/actions'

import {
	forceDownload,
	formatFileSize,
	hasFailed
} from 'utils'

class ModalPreview extends Component {
	state = {
		currentIndex: 0,
	}

	hasMovedMouseSinceShowingControls = false
	areControlsForcedVisible = false
	hoverTimeout = null
	disablePropagate = false
	scrollValueX = 0
	isComponentMounted = true

	UNSAFE_componentWillMount() {
		this.setState({
			currentIndex: this.props.data.startIndex,
			transitionDirection: null
		})

		document.addEventListener('mousemove', this.handleMouseMove)
		document.addEventListener('keyup', this.handleKeyUp)

		setTimeout(() => {
			const outer = document.querySelector('.preview-files')

			document.body.addEventListener('click', this.dismiss)

			if(outer){
				outer.addEventListener('click', e => {
					this.dismiss()
				})
			}
		},500)
	}

	componentDidMount() {
		setTimeout(_ => {
			this.setState({
				areControlsVisible: true
			})
		}, 300)
	}

	componentWillUnmount() {
		document.removeEventListener('mousemove', this.handleMouseMove)
		document.removeEventListener('keyup', this.handleKeyUp)
		document.body.removeEventListener('click', this.dismiss)

		this.isComponentMounted = false
	}

	handleSwipe = startOrEnd => {
		if (startOrEnd == 'start') {
			this.setState({
				scrollValueX: 0
			})
		}
	}

	handleMouseMove = _ => {
		this.hasMovedMouseSinceShowingControls = true

		this.setControlsVisible()
	}

	handleKeyUp = e => {
		const visibleIndices = this.getVisibleIndices()

		if (visibleIndices.length <= 1) {
			return
		}

		switch (e.code) {
			case 'Space':
			case 'Escape':
				this.props.closeCallback()
				e.stopPropagation()
				break
			case 'ArrowLeft':
				this.moveVersion('left')
				break
			case 'ArrowRight':
				this.moveVersion('right')
				break
		}
	}

	dismiss = _ => {
		setTimeout(_ => {
			if (!this.disablePropagate) {
				this.props.closeCallback()
			}
		}, 1)
	}

	setControlsVisible = _ => {
		if (!this.state.areControlsVisible) {
			this.setState({
				areControlsVisible: true
			})
		}

		this.hasMovedMouseSinceShowingControls = false

		if (this.hoverTimeout) {
			clearTimeout(this.hoverTimeout)
		}

		this.hoverTimeout = setTimeout(_ => {
			if (!this.hasMovedMouseSinceShowingControls && !this.areControlsForcedVisible && this.isComponentMounted) {
				this.setState({
					areControlsVisible: false
				})
			}
		}, 2000)
	}

	setForcedControlsVisibility = isForced => {
		this.areControlsForcedVisible = isForced
	}

	getVisibleIndices = _ => {
		const {
			data
		} = this.props

		const {
			files,
			versions
		} = data

		const {
			currentIndex
		} = this.state

		let visibleIndices = []

		const indicesContainer = files ? files : versions

		if (indicesContainer.length == 1) {
			visibleIndices = [0]
		} else if (indicesContainer.length == 2) {
			if (!currentIndex) {
				visibleIndices = [1, 0, 1]
			} else {
				visibleIndices = [0, 1, 0]
			}
		} else {
			if (currentIndex > 0) {
				visibleIndices = [(currentIndex - 1), currentIndex, (indicesContainer[(currentIndex + 1)] ? currentIndex + 1 : 0)]
			} else {
				visibleIndices = [(indicesContainer.length - 1), 0, 1]
			}
		}

		return visibleIndices
	}

	moveVersion = direction => {
		const {
			currentIndex
		} = this.state

		const {
			data
		} = this.props

		const {
			files,
			versions
		} = data

		const indicesContainer = files ? files : versions

		this.setState({
			transitionDirection: direction
		})

		setTimeout(_ => {
			this.setState({
				transitionDirection: null,
				currentIndex: direction == 'left' ? (currentIndex > 0 ? currentIndex - 1 : indicesContainer.length - 1) : (currentIndex < (indicesContainer.length - 1) ? currentIndex + 1 : 0)
			})
		}, 350)

	}

	stopPropagation = _ => {
		this.disablePropagate = true

		setTimeout(_ => {
			this.disablePropagate = false
		}, 2)
	}

	downloadFile = file => {
		if (file.latestVersion.url) {
			forceDownload(file.latestVersion)
		}
	}

	render() {
		const {
			data,
			openModal,
			allFiles,
			closeCallback
		} = this.props

		const {
			files,
			versions
		} = data

		const {
			transitionDirection,
			areControlsVisible
		} = this.state

		const visibleIndices = this.getVisibleIndices()

		const activeIndex = visibleIndices.length == 1 ? 0 : 1

		const filesOrVersions = files ? 'files' : 'versions'

		const className = `preview-displays ${transitionDirection ? `transition-${transitionDirection}` : ''}`

		let activeVersion = null

		if (filesOrVersions === 'files') {
			if (files[visibleIndices[activeIndex]]) {
				activeVersion = files[visibleIndices[activeIndex]].latestVersion
			}
		} else {
			activeVersion = versions[visibleIndices[activeIndex]]
		}

		if (!activeVersion) {
			return null
		}

		let disabledMessage = null

		if (hasFailed(activeVersion)) {
			disabledMessage = 'Upload failed'
		} else if (!activeVersion.url) {
			disabledMessage = 'Still uploading...'
		}

		const fileControls = [
			{
				label: 'Delete',
				icon: 'fe-trash-2',
				callback: file => {
					closeCallback()

					setTimeout(_ => {
						openModal('delete', 'file', {
							data: file
						})
					}, 100)
				}
			},
			{
				label: 'Download',
				icon: 'fe-download',
				callback: this.downloadFile,
				disabledMessage
			},
		]

		data.path && fileControls.splice(1, 0, {
			label: 'See details',
			icon: 'fe-info',
			callback: file => {
				setTimeout(_ => {
					openModal('inspect', 'file', {
						file
					})
				}, 1)
			}
		})

		return (
			<div className={areControlsVisible ? 'visible' : null} id="modal-preview">
				<div className="file-controls">
					{fileControls.map((control, index) => {
						return (
							<div
								key={index}
								style={{
									transitionDelay: (index / 10) + 's'
								}}
							>
								<button
									className={'tooltip-trigger'}
									disabled={control.disabledMessage}
									onClick={_ => {
										let file = null

										if (filesOrVersions == 'files') {
											file = files[visibleIndices[activeIndex]]
										} else {
											const version = versions[visibleIndices[activeIndex]]
											file = allFiles[version.file_id]
										}

										control.callback(file)
									}}
								>
									<Icon name={control.icon} />
									<div className="tooltip">
										{control.disabledMessage ? control.disabledMessage : control.label}
									</div>
								</button>
							</div>
						)
					})}
				</div>
				<ul className={className} onClick={this.stopPropagation}>
					{visibleIndices.map((index, loopIndex) => {
						const version = filesOrVersions == 'files' ? files[index].latestVersion : versions[index]

						return (
							<li
								className={(loopIndex === activeIndex) ? 'active' : null}
								key={`${index}_${loopIndex}`}
							>
								<Swipeable
									onSwipedLeft={_ => {
										this.moveVersion('right')
									}}
									onSwipedRight={_ => {
										this.moveVersion('left')
									}}
								>
									<div>
										<FileDisplay
											isFullSize={true}
											file={version}
											isFromPreview={true}
											downloadFile={this.downloadFile}
										/>
										<span className="filename">
											{version.filename}
											<span className="meta">
												{hasFailed(version) ? 'Upload failed' : formatFileSize(version)}
											</span>
										</span>
									</div>
								</Swipeable>
							</li>
						)
					})}
				</ul>
				{visibleIndices.length > 1 &&
					<div className="preview-controls" onClick={this.stopPropagation}>
						{['left', 'right'].map((direction, index) => {
							return (
								<button
									key={index}
									onClick={e => {
										this.moveVersion(direction)
									}}
									onMouseEnter={_ => {
										this.setForcedControlsVisibility(true)
									}}
									onMouseLeave={_ => {
										this.setForcedControlsVisibility(false)
									}}
									onKeyUp={e => {
										e.preventDefault()
										e.stopPropagation()
									}}
								>
									<Icon name={`angle-${direction}`} />
								</button>
							)
						})}
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = state => ({
	allFiles: state.account.entities.files
})

export default withRouter(connect(mapStateToProps, { openModal, deleteFile })(ModalPreview))